var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconionicIosPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-people",
    "data-name": "Icon ionic-ios-people",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.014,
    height: 80,
    viewBox: "0 0 111.014 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M71.961,69.3c-3.071-1.1-8.088-1.151-10.308-2-1.535-.6-3.975-1.261-4.77-2.221s-.8-7.814-.8-7.814A12.622,12.622,0,0,0,58.8,53.424c.8-2,1.316-7.539,1.316-7.539s1.809.768,2.522-2.851c.6-3.125,1.755-4.77,1.453-7.073-.329-2.3-1.59-1.755-1.59-1.755s1.59-2.33,1.59-10.254c0-8.17-6.169-16.2-17.711-16.2-11.515,0-17.738,8.06-17.738,16.2,0,7.923,1.563,10.254,1.563,10.254s-1.289-.548-1.59,1.755c-.329,2.3.822,3.948,1.453,7.073.713,3.646,2.522,2.851,2.522,2.851s.521,5.511,1.316,7.539a12.622,12.622,0,0,0,2.714,3.838s0,6.854-.8,7.814-3.235,1.618-4.77,2.193c-2.193.85-7.21.96-10.308,2.056A19.349,19.349,0,0,0,8.191,87.748h76.3A19.311,19.311,0,0,0,71.961,69.3Z",
    transform: "translate(9.567 -7.748)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M27.6,40.833s5.593-.187,7.816-2.176c-3.627-5.5-1.661-11.911-2.41-17.9-.749-5.967-4.142-9.548-10.928-9.548h-.094c-6.552,0-10.086,3.557-10.835,9.548-.749,5.967,1.334,13.1-2.387,17.9C10.99,40.67,16.606,40.6,16.606,40.6h0s.234,3.37-.234,3.931a5.909,5.909,0,0,1-2.808,1.287A54.3,54.3,0,0,0,7.5,47.5c-1.825.632-5.289,4.025-5.289,8.705H21.006c.515-1.872,4.048-5.218,7.488-6.973,2.106-1.076,4.189-1.006,5.78-1.217,0,0,.889-1.4-2.036-1.942,0,0-4.025-1.006-4.493-1.568C27.3,43.993,27.6,40.833,27.6,40.833Z",
    transform: "translate(-2.215 10.773)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M31.624,40.833s-5.593-.187-7.816-2.176c3.627-5.5,1.661-11.911,2.41-17.9.749-5.967,4.142-9.548,10.928-9.548h.094c6.552,0,10.086,3.557,10.835,9.548.749,5.967-1.334,13.1,2.387,17.9C48.238,40.67,42.622,40.6,42.622,40.6h0s-.234,3.37.234,3.931a5.909,5.909,0,0,0,2.808,1.287A54.3,54.3,0,0,1,51.725,47.5c1.825.632,5.289,4.025,5.289,8.705H38.223c-.515-1.872-4.048-5.218-7.488-6.973-2.106-1.076-4.189-1.006-5.78-1.217,0,0-.889-1.4,2.036-1.942,0,0,4.025-1.006,4.493-1.568C31.928,43.993,31.624,40.833,31.624,40.833Z",
    transform: "translate(54 10.773)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosPeople);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-people.0a1efc1fc396289ce86640b2eade87a8.svg";
export { ForwardRef as ReactComponent };